import { render } from "./ListStatus.vue?vue&type=template&id=08c854ef"
import script from "./ListStatus.vue?vue&type=script&lang=js"
export * from "./ListStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__